module.exports = __webpack_public_path__ + "img/g4.342db6b5.png";